import { render, staticRenderFns } from "./ProductImport.vue?vue&type=template&id=381cdbac&scoped=true"
import script from "./ProductImport.vue?vue&type=script&lang=js"
export * from "./ProductImport.vue?vue&type=script&lang=js"
import style0 from "./ProductImport.vue?vue&type=style&index=0&id=381cdbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cdbac",
  null
  
)

export default component.exports